import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import TimeUtils from "@/utils/time-utils";
import {InterfaceMode, Player} from "@/store/player/types";
import {Keys} from "@/constants/key";
import {Fonts} from "@/constants/font";
import Text = Phaser.GameObjects.Text;
import Image = Phaser.GameObjects.Image;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class HealthTimerPanel extends Phaser.GameObjects.Container {

    private clickCallback: (() => unknown) | undefined;

    private readonly player!: Player;
    private timeText: Text | undefined;
    private mode: InterfaceMode;

    constructor(scene: Scene, x: number, y: number, player: Player, clickCallback: () => unknown,
                m: InterfaceMode = InterfaceMode.ORIGINAL) {
        super(scene);
        this.clickCallback = clickCallback;
        this.player = player;
        this.setDepth(900);
        this.mode = m;

        this.scene = scene;
        this.x = x;
        this.y = y;

        const back = this.createBack(m);

        let plusText = TextUtils.addTextByFamily(this.scene, '+1',
            12, -20, '#ffffff', 8, 'bold', 450, Fonts.ARIAL_MT).setOrigin(0.5, 0.5);

        const heart = SpriteUtils.addImage(this.scene, 33, -20, Keys.ATLAS_PROFILE, Keys.IMG_HEART_ICON)
            .setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(heart, 18 * CU.S, 16 * CU.S)

        const plus = SpriteUtils.addImage(this.scene, m === InterfaceMode.ORIGINAL ? 165 : 115,
            m === InterfaceMode.ORIGINAL ? -26 : -21, Keys.ATLAS_UI, Keys.GREEN_PLUS).setOrigin(0.5, 0.5);
        if (m === InterfaceMode.MODERN) {
            SpriteUtils.scale(plus, 0.85);
        }

        plus.setInteractive().on('pointerup', () => {
            clickCallback();
        });

        this.add([back, plusText, heart, plus]);

        this.refreshTimer();
    }

    private createBack(interfaceMode: InterfaceMode): Image {
        switch (interfaceMode) {
            case InterfaceMode.ORIGINAL:
                return SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_UI, Keys.HEALTH_TIMER_BACK).setOrigin(0, 1);
            case InterfaceMode.MODERN:
                return SpriteUtils.addImage(this.scene, -20, 1, Keys.ATLAS_UI_2, Keys.UI2_RES, 1.6, 1).setOrigin(0, 1);
        }
    }

    public refreshTimer(): boolean {
        if (this.player && this.player.healthRecoverAt && this.player.healthRecoverAt > 0) {
            let inTxt = this.mode === InterfaceMode.ORIGINAL ? Tr('cherez') : ' ';
            const remainSec = Math.floor((this.player.healthRecoverAt - TimeUtils.getServerTimeMs()) / 1000);
            if (this.timeText) {
                this.timeText.setText(inTxt + TimeUtils.getDurationText(Math.max(remainSec, 0)).toUpperCase());
            } else {
                this.timeText = TextUtils.addTextAdvanced(this.scene, inTxt + TimeUtils.getDurationText(remainSec).toUpperCase(),
                    46, -20, '#ffffff', 8, 'bold', 450, 'left', 2, Fonts.ARIAL_MT)
                    .setOrigin(0, 0.5);
                this.add(this.timeText);
            }
            return remainSec < 0;
        }
        return false;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

}
